import { Component } from '@angular/core';
import { POLICY_DOC_ANNUITY_DOCTYPE } from '../../../../../../common/js/constants/policy-doc';
import { BasePolicyLinksComponent } from '../../../../../../coverpath-common/angular/components/account-center/policy-links/base-policy-links.component';
import { PolicyLink } from '../../../../../../coverpath-common/angular/interfaces/account-center/PolicyLink';
import { AccountCenterService } from '../../../../../../coverpath-common/angular/services/account-center/account-center.service';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ModalService } from '../../../../../../coverpath-common/angular/services/modal/modal.service';

@Component({
  selector: 'annuity-links',
  moduleId: module.id,
  templateUrl: './annuity-links.component.html',
})
export class AnnuityLinksComponent extends BasePolicyLinksComponent {
  ngOnInit(): void {
    this.subscribeToAccountCenterService();
  }

  constructor(
    accountCenterService: AccountCenterService,
    amorphicService: AmorphicService,
    modalService: ModalService
  ) {
    super(accountCenterService, amorphicService, modalService);
  }

  async constructLinks(workflowAction: string): Promise<void> {
    if (this.hasInForcePolicy || this.hasCanceledPolicy) {
      this.title = 'Annuity Links';
      return this.constructLinksForPolicyMode(workflowAction);
    } else {
      this.title = 'Application Links';
      return this.constructLinksForApplicationMode(workflowAction);
    }
  }

  async constructLinksForApplicationMode(workflowAction: string): Promise<void> {
    this.topLinks = await this.getAnnuityDocLinks();
  }

  private async getAnnuityDocLinks() {
    const policy = this.accountCenterService.primaryPolicy;
    if (policy.applicationSignedDate) {
      const docInfos = await this.accountCenterController.getAnnuityAppDocuments();

      return docInfos.map(
        (docInfo) =>
          new PolicyLink(
            `View ${docInfo.displayName} PDF`,
            this.accountCenterController.getViewAnnuityDocURL(docInfo.type)
          )
      );
    }

    return [];
  }

  async constructLinksForPolicyMode(workflowAction: string): Promise<void> {
    //show a loader if this is the first time rendering the component so we don't have a short-term blank component
    if (this.topLinks.length === 0 && this.bottomLinks.length === 0) {
      this.isLoading = true;
    }
    const isPolicyHeld = await this.accountCenterController.getPAStatusIsPolicyHeld(
      this.accountCenterService.primaryPolicy.policyNumber
    );

    const specialHandling = await this.accountCenterController.getPAStatusSpecialHandling(
      this.accountCenterService.primaryPolicy.policyNumber
    );

    // @TODO HL-36470
    // const ownerResidentialState = this.accountCenterService.primaryPolicy.ownerPersonResidentialAddress.state;

    this.topLinks = new Array<PolicyLink>();
    this.bottomLinks = new Array<PolicyLink>();

    this.topLinks.push(
      new PolicyLink('View Contract PDF', this.accountCenterController.getViewPolicyAdminDocsURL('primary'))
    );

    // @TODO START HL-36470
    //TODO: Test joint owner ship scenario for Annuities
    // const canUseSelfServiceWidgets =
    //   !isPolicyHeld && !specialHandling && !this.accountCenterService.application.primaryPolicy.isJointOwnership();

    //Bank Account
    // if (canUseSelfServiceWidgets) {
    //   this.topLinks.push(new PolicyModal('Change Bank Account', 'bankInfo'));
    // } else {
    //   this.topLinks.push(new PolicyLink('Change Bank Account', CoverpathPolicyLinkConstructor.createBankAccountLink()));
    // }

    //Beneficiaries
    // const canUseBeneWidget = canUseSelfServiceWidgets && ownerResidentialState !== 'MA';
    // if (canUseBeneWidget) {
    //   this.topLinks.push(new PolicyModal('Change Beneficiary', 'beneWidget'));
    // } else {
    //   this.topLinks.push(
    //     new PolicyLink(
    //       'Change Beneficiary',
    //       CoverpathPolicyLinkConstructor.createChangeBeneficiaryLink(ownerResidentialState)
    //     )
    //   );
    // }

    //Owner
    // this.topLinks.push(new PolicyLink('Change Owner', CoverpathPolicyLinkConstructor.creatChangeOwnerLink()));

    // Contact Info
    // if (canUseSelfServiceWidgets) {
    //   this.topLinks.push(new PolicyModal('Update Contact Information', 'contactWidget'));
    // } else {
    //   this.topLinks.push(
    //     new PolicyLink('Update Contact Information', CoverpathPolicyLinkConstructor.createMailingAddressLink())
    //   );
    // }

    // //Name
    // this.topLinks.push(new PolicyLink('Change Name', CoverpathPolicyLinkConstructor.createChangeNameLink()));

    // //Face Amount
    // this.topLinks.push(
    //   new PolicyLink('Change Face Amount', CoverpathPolicyLinkConstructor.createChangeFaceAmountLink())
    // );

    // //Cancel
    // if (/Pending Policy Docs/.test(workflowAction)) {
    //   // skip any cancellation link for these stages
    // } else {
    //   this.bottomLinks.push(new PolicyModal('Cancel Annuity', 'cancelPolicy'));
    // }
    // @TODO END HL-36470

    this.isLoading = false;
  }
}
